import api from './api';

export const adminUserService = {
    getUsers: (params) => {
        return api.get('/admin/users', { params });
    },
    createUser: (data) => {
        return api.post('/admin/users', data);
    },
    updateUser: (id, data) => {
        return api.put(`/admin/users/${id}`, data);
    },
    deleteUser: (id) => {
        return api.delete(`/admin/users/${id}`);
    }
};
